import styled from 'styled-components';

type StyledProps = {
    size?: number;
};

export default styled.div<StyledProps>`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 4;

    cursor: pointer;
    && svg {
        width: ${({ size }) => (size ? size : '24')}px;
        color: var(--font-color-subtle);
    }
`;
